<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        <div class="row">
            Uniform Issued Details
        </div>
    </div>
    <div class="card-body" style="overflow: auto; height: 450px;">
        <div class="row">
            <div class="col-md mx-1 px-1 bghighlight">
                <label class="text-label">Employee</label><br />
                <label class="Label1">
                    <div class="row no-gutters cursor-pointer" style="align-items: center;width: 300px;">
                        <div class="col-2">
                            <img *ngIf="InputData.Photo != null && InputData.Photo != ''" mat-card-image
                                class="userImage" [src]="common.PhotoLink(InputData.Photo)" />
                            <div *ngIf="InputData.Photo == null || InputData.Photo == ''" class="initial-image">
                                <div class="image">
                                    {{common.getInitial(InputData.EmpName)}}
                                </div>
                            </div>
                        </div>
                        <div class="col-9 userdetail">
                            <span class="text-label">{{InputData.EmpName}}</span><br />
                            <span class="text-label-light">#{{InputData.EmpCode}}</span><br />
                            <span class="text-label-light">{{InputData.DesignationName}}</span>
                        </div>
                    </div>
                </label>
            </div>
            <div class="col-md mx-1 px-1 bghighlight">
                <div class="row">
                    <div class="text-label">Document No</div>
                </div>
                <div class="row text-right">
                    <div>{{Filter.DocumentNo}}</div>
                </div>
            </div>
            <div class="col-md mx-1 px-1 bghighlight">
                <div class="row">
                    <div class="text-label">Issue Date</div>
                </div>
                <div class="row text-right">
                    <div>{{Filter.IssueDate}}</div>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 3px;">
            <div class="col-md mx-1 px-1 bghighlight">
                <div class="row">
                    <div class="text-label">Branch</div>
                </div>
                <div class="row text-right">
                    <div>{{Filter.Branch}}</div>
                </div>
            </div>
            <div class="col-md mx-1 px-1 bghighlight">
                <div class="row">
                    <div class="text-label">Issue Type</div>
                </div>
                <div class="row text-right">
                    <div>{{Filter.IssueType}}</div>
                </div>
            </div>
        </div>
        <div class="card border-radius-0 mt-1 p-0">
            <div class="card-header">
                Data
            </div>
            <div class="card-body p-1" style="overflow: auto;">
                <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                    class="customeDatatable table table-bordered">
                    <thead class="table-light">
                        <tr>
                            <th scope="col" style="display: none;">Document No</th>
                            <th scope="col" style="display: none;">Issue Date</th>
                            <th scope="col" style="display: none;">Branch</th>
                            <th scope="col" style="display: none;">Issue Type</th>
                            <th scope="col">From Warehouse</th>
                            <th scope="col">Product Code</th>
                            <th scope="col">Product Description</th>
                            <th scope="col">Size</th>
                            <th scope="col">Qty Issued</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let site of DocumentDetails; let i = index">
                            <td style="display: none;">{{ site['DocumentNo'] }}</td>
                            <td style="display: none;">{{ site['IssueDate'] }}</td>
                            <td style="display: none;">{{ site['Branch'] }}</td>
                            <td style="display: none;">{{ site['IssueType'] }}</td>
                            <td>{{ site['From Warehouse'] }}</td>
                            <td>{{ site['ProductCode'] }}</td>
                            <td>{{ site['ProductDesc'] }}</td>
                            <td>{{ site['Size'] }}</td>
                            <td>{{ site['QtyIssued'] }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled" (click)="Cancel()"
                    autofocus="true" #cancelButton id="cancelButton">
                    <i class="bi bi-x-lg" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>